/* eslint-disable require-jsdoc */
import {getFetch, postFetch} from './fetch/fetch';
import {getAjax, postAjax} from './ajax/ajax';
import {useFetch} from '../config';

async function getHttp(hearbyApiKey, url, auth) {
  return useFetch ? await getFetch(hearbyApiKey, url, auth) : await getAjax(hearbyApiKey, url, auth);
}

async function postHttp(hearbyApiKey, url, auth) {
  return useFetch ? await postFetch(hearbyApiKey, url, auth) : await postAjax(hearbyApiKey, url, auth);
}

export default {
  get: getHttp, post: postHttp,
};


// async function getFetch(args) {
//   let result;
//   await fetch(args)
//   // let result;
//       .then((response) =>{
//         result = response.json();
//         console.log(response);
//       })
//       .catch((error) => console.log(error));
//   // .then(data => data)
//   return result;
// }

